import React, { useEffect, Fragment } from "react";
import { withStyles } from "@material-ui/styles";
import { Grid } from "@material-ui/core";
import EdiRequest from "../../components/EdiRequest/EdiRequest";
import ResponseRecords from "../../components/ResponseRecords/ResponseRecords";
import { useSelector, useDispatch } from "react-redux";
import { fetchEdidata } from "../../store/action/ediResponse";
import { clearSelectedEdiRecords } from "../../store/action/selectedRecords";
import Loader from "../../components/Loader/loader";
import RequestRecords from "../../components/RequestRecords/RequestRecords";
import {
  clearEdiResponseRecords,
  clearEdiRequestRecords,
} from "../../store/action/respRecordsClear";
import { clearFileSuccessPopup } from "../../store/action/fileEdiRequest";
import { clearRecordCreatedPopup } from "../../store/action/createRecord";
import { clearRecordDeletedPopup } from "../../store/action/deleteRecords";
const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(4),
  },
});
const ResponseRecorsCountryMap = {
  GB: "ediTxnResponse",
  US: "ediTxnResponse",
  CA: "cbsaTxnResponse",
  CA_CARM: "carmTransactionResponses"
};
function Dashboard(props) {
  //const shipmentID = useSelector((state) => window.shipmentId || window.shipmentId || state.isf?.shipmentID || props.shipmentId);
  const loader = useSelector((state) => state.edi.loading);
  const resloader = useSelector((state) => state.ediResp.loading);
  const dispatch = useDispatch();
  const RecordsData = useSelector((state) => state.ediResp.ediRespRecords);
  let isXMLEnabled = false;
  if(props.currentShipmentStates?.states){
    let goodsReleasedState=props.currentShipmentStates.states.filter((item)=> item.key==="SHIPMENT_RNS_PROCESS")?.[0]?.value;
    isXMLEnabled = props.formType === "CARM" && (goodsReleasedState.state === "STATE_RNS_GOODS_RELEASED" || props.isLvsShipment);
  }
  
  const country = useSelector(
    (state) =>
      isXMLEnabled ? 
      "CA_CARM" :
      window.shipmentCountry ||
      window.shipmentCountry ||
      state.isf?.currentJobData.shipment.countryOfBusiness ||
      props.countryOfBusiness
  );

  const shipmentId = useSelector(
    (state) =>
      window.shipmentId ||
      state.isf?.currentJobData.shipmentID ||
      props.shipmentId
  );

  const responseRecords = RecordsData.eventMessage
    ? RecordsData.eventMessage[ResponseRecorsCountryMap[country]]
    : [];
    console.log("records Data:", responseRecords, RecordsData);
  useEffect(() => {
    dispatch(fetchEdidata(shipmentId, country, isXMLEnabled));
    return () => {
      dispatch(clearEdiResponseRecords());
      dispatch(clearEdiRequestRecords());
      dispatch(clearSelectedEdiRecords());
      dispatch(clearFileSuccessPopup());
      dispatch(clearRecordCreatedPopup());
      dispatch(clearRecordDeletedPopup());
    };
  }, [country, shipmentId, isXMLEnabled]);

  
  return (
    <div
      className={"edi-table-root-top "+props.classes.root}
      style={{
        height: "100%",
        overflow: "scroll",
        overscrollBehavior: "contain",
      }}
    >
      {loader && (
        <div style={{ textAlign: "center" }}>
          {" "}
          <Loader />{" "}
        </div>
      )}

      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Grid container spacing={4}>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <EdiRequest isXMLEnabled={isXMLEnabled} {...props} />
          </Grid>

          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <RequestRecords isXMLEnabled={isXMLEnabled} {...props} />
          </Grid>

          <Grid item lg={12} sm={12} xl={12} xs={12}>
            {resloader ? (
              <div style={{ textAlign: "center" }}>
                {" "}
                <Loader />{" "}
              </div>
            ) : responseRecords && resloader == false ? (
              <Fragment>
                <ResponseRecords isXMLEnabled={isXMLEnabled} {...props} />
              </Fragment>
            ) : !responseRecords && resloader == false ? (
              <Fragment>
                <div style={{ textAlign: "center" }}>
                  <h3 style={{ fontFamily: "Courier New" }}>
                    No response record found !
                  </h3>
                </div>
                <table className="req-table">
                  <thead>
                    <tr>
                      {[...Array(50)].map((e, i) => (
                        <th key={i}>{i + 1}</th>
                      ))}
                    </tr>
                  </thead>
                </table>
              </Fragment>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* </Grid> */}
    </div>
  );
}
export default withStyles(useStyles)(Dashboard);
